import { TakeNoteBox } from "components/TakeNoteBox/TakeNoteBox"
import { TestData } from "graphql/types"

type NoteTaskProps = {
  data: TestData
  setData: (data: TestData) => void
}

export const NoteTask = (props: NoteTaskProps) => {
  const { data, setData } = props
  return <TakeNoteBox data={data} setData={setData} name="Notiz " />
}
